import timeclockImage from '../../assets/images/premium-features/mobile-tc.png';
import kioskImage from '../../assets/images/premium-features/kiosk.png';
import earlyClockInImage from '../../assets/images/premium-features/x-clockin-out.png';
import geofencingImage from '../../assets/images/premium-locked-screen/timeclock/geofencing.png';
import timesheetsImage from '../../assets/images/premium-locked-screen/timeclock/timesheets.png';
import { PREMIUM_FEATURE_NAMES } from '../../../src/constants';

import timeclockPreviewUrl from './timeclockPreviewComponent.html';

class TimeclockPreviewController {
  TIMECLOCK_FEATURE_NAME = PREMIUM_FEATURE_NAMES.timeclock;

  constructor(Authentication) {
    'ngInject';

    Object.assign(this, { Authentication });
  }

  $onInit() {
    this.timeclockImage = timeclockImage;
    this.timesheetsImage = timesheetsImage;
    this.kioskImage = kioskImage;
    this.geofencingImage = geofencingImage;
    this.earlyClockInImage = earlyClockInImage;
  }
}

export default {
  controller: TimeclockPreviewController,
  controllerAs: 'ctrl',
  templateUrl: timeclockPreviewUrl,
};
